// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bread-themed color palette */
:root {
  --afterdark-bg-color: #000000;
  --afterdark-text-color: #ffffff;
  --afterdark-accent-color: rgb(8, 2, 44);
}

/* ---------------------------------------------------------------------------
   AFTER DARK, for everything the card is not.

   The page below is already decided: black, a photograph turned almost all the
   way down, and a card header that is a deep indigo gradient (#070928 -> #031024)
   with stars in it. What follows is that same night carried into the "Verified
   this show" window, its launcher, the toasts and the hosts strip -- so they
   read as pieces of the dark page rather than daylight left switched on.

   The two ideas it is built from:

   INDIGO, NOT GREY. Every surface is a lift of the header's own colour rather
   than a neutral charcoal, so a panel laid over the card looks like the same
   night one step nearer: #131a41 over the header's #070928.

   MOONLIGHT, NOT ORANGE. The accent is #9ab0ff -- the colour of the stars in
   the header and of the After Dark wordmark, not a dimmed version of the
   daytime burnt orange, which on this background reads as a smouldering ember
   and fights everything around it. It is light rather than dark, so where the
   day look fills a shape with the accent and writes on it in white, this fills
   it with moonlight and writes in near-black.

   The bingo squares are deliberately NOT touched: their cream paper is the
   product, and this look has always kept them lit against the dark.
--------------------------------------------------------------------------- */

:root {
  --wsb-surface: #131a41;
  --wsb-surface-2: #0d1231;
  --wsb-surface-image: none;
  --wsb-surface-hover: linear-gradient(to bottom, #1e2758, #161d47);
  /* The launcher sits on the header's own indigo, so it needs its edge drawn. */
  --wsb-ring: rgba(154, 176, 255, 0.38);

  --wsb-ink: #e9eeff;
  --wsb-ink-muted: #a9b5e0;

  --wsb-line: rgba(154, 176, 255, 0.22);
  --wsb-line-strong: rgba(154, 176, 255, 0.5);
  --wsb-shadow: rgba(0, 0, 0, 0.7);

  --wsb-accent: #9ab0ff;
  --wsb-accent-ink: #0a0e26;

  --wsb-bar-bg: linear-gradient(45deg, #232c63, #10163a);
  --wsb-bar-ink: #eef2ff;
  --wsb-bar-ink-muted: #b9c5f0;
  --wsb-bar-glint: #cdd8ff;
  --wsb-bar-hover: rgba(205, 216, 255, 0.18);

  --wsb-badge-bg: #9ab0ff;
  --wsb-badge-ink: #0a0e26;

  --wsb-chip-bg: rgba(154, 176, 255, 0.13);
  --wsb-accent-text: #bcc9ff;
  --wsb-chip-line: rgba(154, 176, 255, 0.42);

  --wsb-focus: #cdd8ff;
  --wsb-snap-ring: rgba(154, 176, 255, 0.75);

  /* On the header the day look darkens; here it lifts. A black wash on indigo
     is a hole in the card, a pale one is a pane of light on it. */
  --wsb-onbrand-panel: rgba(154, 176, 255, 0.1);
  --wsb-onbrand-line: rgba(154, 176, 255, 0.3);
  --wsb-onbrand-ink: #e6ecff;
  --wsb-onbrand-ink-muted: rgba(230, 236, 255, 0.78);

  /* Nearly opaque: a translucent toast over the dark page turned muddy. */
  --wsb-toast-bg: rgba(24, 31, 74, 0.94);
  --wsb-toast-bg-idle: rgba(15, 20, 52, 0.94);
  --wsb-toast-ink: #e9eeff;

  /* Red stays red -- "on air" is not a matter of taste. The halo on a confirmed
     square turns to moonlight, which on cream paper against a black page reads
     as light falling on it rather than a warm lamp behind it. */
  --wsb-verified-glow-soft: rgba(174, 196, 255, 0.22);
  --wsb-verified-glow-strong: rgba(174, 196, 255, 0.6);
}

/* Reset and base styles */
* {
  font-family: 'Helvetica', sans-serif;
  padding: 0;
  margin: 0;
}

body {
  background-color: var(--afterdark-bg-color);
  z-index: -4;
}

#my-canvas {
  position: absolute; /* Position the canvas absolutely within the parent */
  top: 0;
  left: 0;
  z-index: 0; /* Set a lower z-index value to place it behind other elements */
}

#back-img {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  /* background-color: #000; */
  /* background-image: linear-gradient(to bottom, #6699ff, #ff66cc); */
  background-image: url("https://cdn.wanshow.bingo/resources/images/background5.jpeg");
  background-size: cover;
  background-position: center;
  z-index: -2;
  opacity: 0.2;
  overflow: hidden;
}

.user-count {
  animation: typing 0.5s steps(20, end);
}

nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: var(--afterdark-accent-color);
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
}

.nav-logo img {
  height: 40px;
}

.nav-links a {
  color: white;
  text-decoration: none;
  margin: 0 10px;
  font-size: 18px;
}

.nav-login a {
  color: white;
  text-decoration: none;
  font-size: 18px;
}

@keyframes typing {
  from {
    width: 0;
  }
}

/* Style for the menu items */
.menu {
  display: none;
  position: absolute;
  top: 48px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.menu a {
  display: block;
  padding: 12px 16px;
  text-decoration: none;
  color: #333;
  transition: background-color 0.3s;
}

.menu a:hover {
  background-color: #ddd;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
}

/* Apply styles to the theme selector dropdown */
#themeSelector {
  background-color: #d2480c;
  border: 1px solid #9a3206;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  color: #ffffff;
}

/* Apply styles to the label of the theme selector dropdown */
.theme-selector-label {
  font-weight: bold;
  color: #ffffff;
}


@keyframes typing {
  from {
    width: 0;
  }
}

#bodyWrapper {
  width: 1000px;
  display: block;
  margin: 0px auto;
  padding-top: 50px;
  padding-bottom: 50px;
}

#game {
  /* width: 100%; */
  display: inline-block;
  /* background-color: var(--afterdark-accent-color); */
  padding: 15px 10px;
  padding-left: 2.5px;
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
  background: linear-gradient(to bottom, #070928, #031024);
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 10px 5px rgba(255, 255, 255, 0.111);
}

#game::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000042;
  z-index: -1;
}

/* General style for stars */
.star {
  position: absolute;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8); /* Soft glow for stars */
  animation: fadeIn 5s ease-in-out forwards; /* Fade in animation */
}

/* Fade in animation */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Create individual stars with random positions and sizes */
.star1 { top: 10%; left: 15%; width: 3px; height: 3px; }
.star2 { top: 20%; left: 30%; width: 2px; height: 2px; }
.star3 { top: 2%; left: 80%; width: 4px; height: 4px; }
.star4 { top: 50%; left: 60%; width: 3px; height: 3px; }
.star5 { top: 70%; left: 40%; width: 2px; height: 2px; }
.star6 { top: 35%; left: 10%; width: 3px; height: 3px; }
.star7 { top: 75%; left: 70%; width: 2px; height: 2px; }
.star8 { top: 93%; left: 20%; width: 4px; height: 4px; }
.star9 { top: 25%; left: 75%; width: 3px; height: 3px; }
.star10 { top: 85%; left: 50%; width: 2px; height: 2px; }
.star11 { top: 83%; left: 40%; width: 4px; height: 4px; }
.star12 { top: 81%; left: 85%; width: 3px; height: 3px; }
.star13 { top: 10%; left: 65%; width: 2px; height: 2px; }
.star14 { top: 98%; left: 25%; width: 4px; height: 4px; }
.star15 { top: 55%; left: 45%; width: 3px; height: 3px; }

#game p {
  line-height: 30px;
  text-shadow: 1px 1px 1px #00000012;
}

#game a {
  color: white;
}

.hidden {
  display: none;
}

.board {
  width: 1000px;
  margin: auto;
  display: block;
}

#whenplane {
  padding-bottom: 10px;
}

#board {
  display: inline-grid; /* added to make the area a grid */
  position: relative; /* Added to position the background image */
  grid-template-columns: auto auto auto auto auto; /* gives the grid 5 columns no matter what size screen you are on */
  z-index: 1;  /*Added to stack the game board above the background image */
  transform-origin: top left; /* Scale from the top left corner */
  /*display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-wrap: wrap; Allow items to wrap onto the next line */
}

#board::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-image: url("https://cdn.wanshow.bingo/resources/images/danbread.png"); */
  background-size: cover;
  background-position: center;
  background-attachment: fixed; /* Changed to fixed to keep the background image in place */
  z-index: -1; /* Stack the background image below the grid items */
}

.item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 5 - 10px); /* adjust the denominator based on how many items you want in a row */
  vertical-align: middle;
  text-align: center;
  width: 178px;
  height: 153px;
  border: 1px #1d1d1d solid;
  background-image: url("https://cdn.wanshow.bingo/resources/images/paper.png");
  float: left;
  color: #000000;
  padding: 10px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.item p {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.title {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-size: 32pt;
}

.clicked {
  background: linear-gradient(to right, #b5226200, #893f8e00);
  color: rgb(0, 0, 0);
  border-color: #f0dddd;
  animation: borderColorChange 2s infinite;
}

@keyframes borderColorChange {
  0% {
    border-color: #FF0000;
  }
  16.67% {
    border-color: #FF6A00;
  }
  33.33% {
    border-color: #FFD800;
  }
  50% {
    border-color: #00FF00;
  }
  66.67% {
    border-color: #0000FF;
  }
  83.33% {
    border-color: #4B0082;
  }
  100% {
    border-color: #9400D3;
  }
}

.footer {
  padding: 1rem 0;
  width: 100%;
  /* position: absolute; */
  bottom: 0;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
}

.footer-links {
  display: flex;
  align-items: center;
}

.footer-links a {
  color: #f2f2f2;
  text-decoration: none;
  margin-right: 1rem;
}

.footer-links a:hover {
  color: #e0e0e0;
}

/* Remove underline from footer & a href */
.footer-links a:hover {
  text-decoration: none;
}

.footer-copyright {
  color: #f2f2f2;
  font-size: 0.9rem;
}

a {
  color: white;
}

a:hover {
  color: #ff6600;
}

#team {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.section {
  flex: 0 0 48%; /* Each section will take up 48% of the available space */
  margin: 10px;
  /* Add media query to stack sections vertically on smaller screens */
}

.discord-banner {
  display: flex;
  align-items: center;
  background-color: #5865F2; /* Discord's blurple color from the color palette */
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.discord-icon {
  font-size: 18px;
  margin-right: 5px;
}

.discord-tag {
  font-size: 14px;
}

.member {
  /* width: calc(50% - 20px); */
  margin: 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
}

.member img {
  width: 150px;
  border-radius: 50%;
}

.member h2 {
  font-size: 24px;
  margin-top: 10px;
}

.member p {
  margin-top: 5px;
}

.member .social-links {
  margin-top: 10px;
}

.member .social-links a {
  color: #555;
  text-decoration: none;
  margin-right: 10px;
  font-size: 18px;
}

.member .social-links a:hover {
  color: #bfbfbf;
}

.countdown-box.svelte-1xheok0 {
  min-width: 23em;
  margin: 0 auto;
  font-family: "Dosis", sans-serif;
  background: linear-gradient(to bottom, #070928, #031024);
  padding: 15px 10px;
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
}

.countdown-box.svelte-1xheok0 {
  width: auto; /* Adjust to content */
  max-width: 550px;
  margin: 20px auto; /* Center the box */
  font-family: 'Dosis', sans-serif;
  background: linear-gradient(to bottom, #070928, #031024);
  padding: 15px 20px; /* Increased padding */
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
  white-space: nowrap; /* Prevents the text from wrapping */
}

.provider-text {
  font-size: 10pt;
  text-align: right;
  color: #ffffff;
}

#wan-show-timer a {
  text-decoration: none;
  color: inherit;
  display: block; /* Make the entire area clickable */
}

.discord-banner {
  display: flex;
  align-items: center;
  background-color: #5865F2; /* Discord's blurple color from the color palette */
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.discord-icon {
  font-size: 18px;
  margin-right: 5px;
}

.discord-tag {
  font-size: 14px;
}

.discord-tag {
  background-color: #5865F2; /* Discord's purple color from the color palette */
  padding: 5px 10px;
  border-radius: 15px;
  display: inline-block;
}

.discord-banner::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  border-radius: 20px;
  z-index: -1;
}

.member {
  margin-bottom: 20px;
}

.section h2 {
  color: white;
}

@media (max-width: 768px) {
  .section {
    flex: 0 0 100%; /* On smaller screens, each section takes up 100% of the available space */
  }
}

@media (max-width: 768px) {
  .member {
    width: calc(50% - 18px);
  }
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    text-align: center;
  }

  .footer-links {
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 3840px) {
  #game {
    transform: scale(1.0); /* Scale down to 90% on smaller screens */
    transform-origin: center;   
  }

  #nav-container {
    transform: scale(0.8); /* Scale down to 80% on even smaller screens */
    transform-origin: center;   
  }
}

@media (max-width: 1920px) {
  #game {
    transform: scale(0.98); /* Scale down to 90% on smaller screens */
    transform-origin: center;   
    padding-left: 10px;
  }

  #whenplane {
    transform: scale(0.98); 
  }
}

@media (max-width: 1200px) {
  #game {
    transform: scale(0.98);  
    transform-origin: center;   
    padding-left: 10px;
    margin-left: 18px;
  }

  #whenplane {
    transform: scale(0.98);
    margin-top: 0px;  
  }
}

@media (max-width: 1150px) {
  #game {
    transform: scale(0.96);  
    transform-origin: center;   
    padding-left: 10px;
    margin-left: 18px;
  }

  #whenplane {
    transform: scale(0.96);
    margin-top: -2px;  
  }
}

@media (max-width: 1100px) {
  #game {
    transform: scale(0.99);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }

  #whenplane {
    transform: scale(0.99);
    margin-top: 0px;  
  }
}

@media (max-width: 1070px) {
  #game {
    transform: scale(0.98);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1060px) {
  #game {
    transform: scale(0.97);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1050px) {
  #game {
    transform: scale(0.96);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1040px) {
  #game {
    transform: scale(0.95);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1030px) {
  #game {
    transform: scale(0.94);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1020px) {
  #game {
    transform: scale(0.93);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1010px) {
  #game {
    transform: scale(0.92);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }

  #whenplane {
    transform: scale(0.92);  
  }
}

@media (max-width: 1000px) {
  #game {
    transform: scale(0.91);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -80px;
  }
}

@media (max-width: 950px) {
  #game {
    transform: scale(0.86);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -100px;
  }
}

@media (max-width: 900px) {
  #game {
    transform: scale(0.81);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -120px;
  }

  #whenplane {
    transform: scale(0.81);
    margin-top: -125px;  
  }
}

@media (max-width: 850px) {
  #game {
    transform: scale(0.76);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -140px;
  }

  #whenplane {
    transform: scale(0.76);
    margin-top: -150px;  
  }
}

@media (max-width: 800px) {
  #game {
    transform: scale(0.71);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 3px;
    margin-top: -160px;
  }

  #whenplane {
    transform: scale(0.71);
    margin-top: -175px;  
  }
}

@media (max-width: 750px) {
  #game {
    transform: scale(0.66);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 2px;
    margin-top: -180px;
  }

  #whenplane {
    transform: scale(0.66);
    margin-top: -200px;  
  }
}

@media (max-width: 600px) {
  #game {
    transform: scale(0.56);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 1px;
    margin-top: -200px;
  }

  #whenplane {
    transform: scale(0.56);
    margin-top: -275px;  
  }
}

@media (max-width: 550px) {
  #game {
    transform: scale(0.52);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -220px;
  }
}

@media (max-width: 500px) {
  #game {
    transform: scale(0.48);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -240px;
  }

  #whenplane {
    transform: scale(0.48);  
    padding-top: -50px;
  }
}

@media (max-width: 480px) {
  #game {
    transform: scale(0.46); /* Scale down to 50% on the smallest screens */
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -248px;
  }
}

@media (max-width: 450px) {
  #game {
    transform: scale(0.42);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -260px;
  }
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }

  .hamburger-menu {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/BingoCard-AFTERDARK.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;6EAwB6E;;AAE7E;EACE,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,iEAAiE;EACjE,8EAA8E;EAC9E,qCAAqC;;EAErC,kBAAkB;EAClB,wBAAwB;;EAExB,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;;EAEhC,qBAAqB;EACrB,yBAAyB;;EAEzB,sDAAsD;EACtD,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,0CAA0C;;EAE1C,uBAAuB;EACvB,wBAAwB;;EAExB,wCAAwC;EACxC,0BAA0B;EAC1B,0CAA0C;;EAE1C,oBAAoB;EACpB,0CAA0C;;EAE1C;kEACgE;EAChE,6CAA6C;EAC7C,4CAA4C;EAC5C,0BAA0B;EAC1B,kDAAkD;;EAElD,wEAAwE;EACxE,sCAAsC;EACtC,2CAA2C;EAC3C,wBAAwB;;EAExB;;gEAE8D;EAC9D,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,UAAU;EACV,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,kBAAkB,EAAE,qDAAqD;EACzE,MAAM;EACN,OAAO;EACP,UAAU,EAAE,gEAAgE;AAC9E;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,oEAAoE;EACpE,oFAAoF;EACpF,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qDAAqD;EACrD,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C,EAAE,wBAAwB;EACvE,yCAAyC,EAAE,sBAAsB;AACnE;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,4DAA4D;AAC5D,SAAS,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACvD,SAAS,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACvD,SAAS,OAAO,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACtD,SAAS,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACvD,SAAS,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACvD,SAAS,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACvD,SAAS,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACvD,SAAS,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACvD,SAAS,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACvD,UAAU,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACxD,UAAU,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACxD,UAAU,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACxD,UAAU,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACxD,UAAU,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;AACxD,UAAU,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE;;AAExD;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB,EAAE,kCAAkC;EACxD,kBAAkB,EAAE,2CAA2C;EAC/D,+CAA+C,EAAE,mEAAmE;EACpH,UAAU,GAAG,4DAA4D;EACzE,0BAA0B,EAAE,mCAAmC;EAC/D;;;2DAGyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B,EAAE,2DAA2D;EACzF,WAAW,EAAE,oDAAoD;AACnE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B,EAAE,qEAAqE;EACnG,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,6EAA6E;EAC7E,WAAW;EACX,cAAc;EACd,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa,EAAE,yDAAyD;EACxE,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,mDAAmD;EAC9E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,wDAAwD;EACxD,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,gBAAgB;EAChB,iBAAiB,EAAE,mBAAmB;EACtC,gCAAgC;EAChC,wDAAwD;EACxD,kBAAkB,EAAE,sBAAsB;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,mDAAmD;EAC9E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,kDAAkD;EAC7E,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc,EAAE,0EAA0E;EAC5F;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB,EAAE,yCAAyC;IAChE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB,EAAE,8CAA8C;IACrE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,yCAAyC;IACjE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,8CAA8C;IACtE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Bread-themed color palette */\n:root {\n  --afterdark-bg-color: #000000;\n  --afterdark-text-color: #ffffff;\n  --afterdark-accent-color: rgb(8, 2, 44);\n}\n\n/* ---------------------------------------------------------------------------\n   AFTER DARK, for everything the card is not.\n\n   The page below is already decided: black, a photograph turned almost all the\n   way down, and a card header that is a deep indigo gradient (#070928 -> #031024)\n   with stars in it. What follows is that same night carried into the \"Verified\n   this show\" window, its launcher, the toasts and the hosts strip -- so they\n   read as pieces of the dark page rather than daylight left switched on.\n\n   The two ideas it is built from:\n\n   INDIGO, NOT GREY. Every surface is a lift of the header's own colour rather\n   than a neutral charcoal, so a panel laid over the card looks like the same\n   night one step nearer: #131a41 over the header's #070928.\n\n   MOONLIGHT, NOT ORANGE. The accent is #9ab0ff -- the colour of the stars in\n   the header and of the After Dark wordmark, not a dimmed version of the\n   daytime burnt orange, which on this background reads as a smouldering ember\n   and fights everything around it. It is light rather than dark, so where the\n   day look fills a shape with the accent and writes on it in white, this fills\n   it with moonlight and writes in near-black.\n\n   The bingo squares are deliberately NOT touched: their cream paper is the\n   product, and this look has always kept them lit against the dark.\n--------------------------------------------------------------------------- */\n\n:root {\n  --wsb-surface: #131a41;\n  --wsb-surface-2: #0d1231;\n  --wsb-surface-image: none;\n  --wsb-surface-hover: linear-gradient(to bottom, #1e2758, #161d47);\n  /* The launcher sits on the header's own indigo, so it needs its edge drawn. */\n  --wsb-ring: rgba(154, 176, 255, 0.38);\n\n  --wsb-ink: #e9eeff;\n  --wsb-ink-muted: #a9b5e0;\n\n  --wsb-line: rgba(154, 176, 255, 0.22);\n  --wsb-line-strong: rgba(154, 176, 255, 0.5);\n  --wsb-shadow: rgba(0, 0, 0, 0.7);\n\n  --wsb-accent: #9ab0ff;\n  --wsb-accent-ink: #0a0e26;\n\n  --wsb-bar-bg: linear-gradient(45deg, #232c63, #10163a);\n  --wsb-bar-ink: #eef2ff;\n  --wsb-bar-ink-muted: #b9c5f0;\n  --wsb-bar-glint: #cdd8ff;\n  --wsb-bar-hover: rgba(205, 216, 255, 0.18);\n\n  --wsb-badge-bg: #9ab0ff;\n  --wsb-badge-ink: #0a0e26;\n\n  --wsb-chip-bg: rgba(154, 176, 255, 0.13);\n  --wsb-accent-text: #bcc9ff;\n  --wsb-chip-line: rgba(154, 176, 255, 0.42);\n\n  --wsb-focus: #cdd8ff;\n  --wsb-snap-ring: rgba(154, 176, 255, 0.75);\n\n  /* On the header the day look darkens; here it lifts. A black wash on indigo\n     is a hole in the card, a pale one is a pane of light on it. */\n  --wsb-onbrand-panel: rgba(154, 176, 255, 0.1);\n  --wsb-onbrand-line: rgba(154, 176, 255, 0.3);\n  --wsb-onbrand-ink: #e6ecff;\n  --wsb-onbrand-ink-muted: rgba(230, 236, 255, 0.78);\n\n  /* Nearly opaque: a translucent toast over the dark page turned muddy. */\n  --wsb-toast-bg: rgba(24, 31, 74, 0.94);\n  --wsb-toast-bg-idle: rgba(15, 20, 52, 0.94);\n  --wsb-toast-ink: #e9eeff;\n\n  /* Red stays red -- \"on air\" is not a matter of taste. The halo on a confirmed\n     square turns to moonlight, which on cream paper against a black page reads\n     as light falling on it rather than a warm lamp behind it. */\n  --wsb-verified-glow-soft: rgba(174, 196, 255, 0.22);\n  --wsb-verified-glow-strong: rgba(174, 196, 255, 0.6);\n}\n\n/* Reset and base styles */\n* {\n  font-family: 'Helvetica', sans-serif;\n  padding: 0;\n  margin: 0;\n}\n\nbody {\n  background-color: var(--afterdark-bg-color);\n  z-index: -4;\n}\n\n#my-canvas {\n  position: absolute; /* Position the canvas absolutely within the parent */\n  top: 0;\n  left: 0;\n  z-index: 0; /* Set a lower z-index value to place it behind other elements */\n}\n\n#back-img {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  /* background-color: #000; */\n  /* background-image: linear-gradient(to bottom, #6699ff, #ff66cc); */\n  background-image: url(\"https://cdn.wanshow.bingo/resources/images/background5.jpeg\");\n  background-size: cover;\n  background-position: center;\n  z-index: -2;\n  opacity: 0.2;\n  overflow: hidden;\n}\n\n.user-count {\n  animation: typing 0.5s steps(20, end);\n}\n\nnav {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  background-color: var(--afterdark-accent-color);\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  padding: 0 20px;\n}\n\n.nav-logo img {\n  height: 40px;\n}\n\n.nav-links a {\n  color: white;\n  text-decoration: none;\n  margin: 0 10px;\n  font-size: 18px;\n}\n\n.nav-login a {\n  color: white;\n  text-decoration: none;\n  font-size: 18px;\n}\n\n@keyframes typing {\n  from {\n    width: 0;\n  }\n}\n\n/* Style for the menu items */\n.menu {\n  display: none;\n  position: absolute;\n  top: 48px;\n  right: 0;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 1;\n}\n\n.menu a {\n  display: block;\n  padding: 12px 16px;\n  text-decoration: none;\n  color: #333;\n  transition: background-color 0.3s;\n}\n\n.menu a:hover {\n  background-color: #ddd;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  padding: 0 20px;\n}\n\n/* Apply styles to the theme selector dropdown */\n#themeSelector {\n  background-color: #d2480c;\n  border: 1px solid #9a3206;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 14px;\n  color: #ffffff;\n}\n\n/* Apply styles to the label of the theme selector dropdown */\n.theme-selector-label {\n  font-weight: bold;\n  color: #ffffff;\n}\n\n\n@keyframes typing {\n  from {\n    width: 0;\n  }\n}\n\n#bodyWrapper {\n  width: 1000px;\n  display: block;\n  margin: 0px auto;\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n#game {\n  /* width: 100%; */\n  display: inline-block;\n  /* background-color: var(--afterdark-accent-color); */\n  padding: 15px 10px;\n  padding-left: 2.5px;\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n  background: linear-gradient(to bottom, #070928, #031024);\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 0 10px 5px rgba(255, 255, 255, 0.111);\n}\n\n#game::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #00000042;\n  z-index: -1;\n}\n\n/* General style for stars */\n.star {\n  position: absolute;\n  background-color: white;\n  border-radius: 50%;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8); /* Soft glow for stars */\n  animation: fadeIn 5s ease-in-out forwards; /* Fade in animation */\n}\n\n/* Fade in animation */\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Create individual stars with random positions and sizes */\n.star1 { top: 10%; left: 15%; width: 3px; height: 3px; }\n.star2 { top: 20%; left: 30%; width: 2px; height: 2px; }\n.star3 { top: 2%; left: 80%; width: 4px; height: 4px; }\n.star4 { top: 50%; left: 60%; width: 3px; height: 3px; }\n.star5 { top: 70%; left: 40%; width: 2px; height: 2px; }\n.star6 { top: 35%; left: 10%; width: 3px; height: 3px; }\n.star7 { top: 75%; left: 70%; width: 2px; height: 2px; }\n.star8 { top: 93%; left: 20%; width: 4px; height: 4px; }\n.star9 { top: 25%; left: 75%; width: 3px; height: 3px; }\n.star10 { top: 85%; left: 50%; width: 2px; height: 2px; }\n.star11 { top: 83%; left: 40%; width: 4px; height: 4px; }\n.star12 { top: 81%; left: 85%; width: 3px; height: 3px; }\n.star13 { top: 10%; left: 65%; width: 2px; height: 2px; }\n.star14 { top: 98%; left: 25%; width: 4px; height: 4px; }\n.star15 { top: 55%; left: 45%; width: 3px; height: 3px; }\n\n#game p {\n  line-height: 30px;\n  text-shadow: 1px 1px 1px #00000012;\n}\n\n#game a {\n  color: white;\n}\n\n.hidden {\n  display: none;\n}\n\n.board {\n  width: 1000px;\n  margin: auto;\n  display: block;\n}\n\n#whenplane {\n  padding-bottom: 10px;\n}\n\n#board {\n  display: inline-grid; /* added to make the area a grid */\n  position: relative; /* Added to position the background image */\n  grid-template-columns: auto auto auto auto auto; /* gives the grid 5 columns no matter what size screen you are on */\n  z-index: 1;  /*Added to stack the game board above the background image */\n  transform-origin: top left; /* Scale from the top left corner */\n  /*display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  flex-wrap: wrap; Allow items to wrap onto the next line */\n}\n\n#board::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* background-image: url(\"https://cdn.wanshow.bingo/resources/images/danbread.png\"); */\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed; /* Changed to fixed to keep the background image in place */\n  z-index: -1; /* Stack the background image below the grid items */\n}\n\n.item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% / 5 - 10px); /* adjust the denominator based on how many items you want in a row */\n  vertical-align: middle;\n  text-align: center;\n  width: 178px;\n  height: 153px;\n  border: 1px #1d1d1d solid;\n  background-image: url(\"https://cdn.wanshow.bingo/resources/images/paper.png\");\n  float: left;\n  color: #000000;\n  padding: 10px;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.item p {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.title {\n  width: 100%;\n  text-align: center;\n  margin-top: 15px;\n  font-size: 32pt;\n}\n\n.clicked {\n  background: linear-gradient(to right, #b5226200, #893f8e00);\n  color: rgb(0, 0, 0);\n  border-color: #f0dddd;\n  animation: borderColorChange 2s infinite;\n}\n\n@keyframes borderColorChange {\n  0% {\n    border-color: #FF0000;\n  }\n  16.67% {\n    border-color: #FF6A00;\n  }\n  33.33% {\n    border-color: #FFD800;\n  }\n  50% {\n    border-color: #00FF00;\n  }\n  66.67% {\n    border-color: #0000FF;\n  }\n  83.33% {\n    border-color: #4B0082;\n  }\n  100% {\n    border-color: #9400D3;\n  }\n}\n\n.footer {\n  padding: 1rem 0;\n  width: 100%;\n  /* position: absolute; */\n  bottom: 0;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.footer-links {\n  display: flex;\n  align-items: center;\n}\n\n.footer-links a {\n  color: #f2f2f2;\n  text-decoration: none;\n  margin-right: 1rem;\n}\n\n.footer-links a:hover {\n  color: #e0e0e0;\n}\n\n/* Remove underline from footer & a href */\n.footer-links a:hover {\n  text-decoration: none;\n}\n\n.footer-copyright {\n  color: #f2f2f2;\n  font-size: 0.9rem;\n}\n\na {\n  color: white;\n}\n\na:hover {\n  color: #ff6600;\n}\n\n#team {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.section {\n  flex: 0 0 48%; /* Each section will take up 48% of the available space */\n  margin: 10px;\n  /* Add media query to stack sections vertically on smaller screens */\n}\n\n.discord-banner {\n  display: flex;\n  align-items: center;\n  background-color: #5865F2; /* Discord's blurple color from the color palette */\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: fit-content;\n}\n\n.discord-icon {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.discord-tag {\n  font-size: 14px;\n}\n\n.member {\n  /* width: calc(50% - 20px); */\n  margin: 10px;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  position: relative;\n}\n\n.member img {\n  width: 150px;\n  border-radius: 50%;\n}\n\n.member h2 {\n  font-size: 24px;\n  margin-top: 10px;\n}\n\n.member p {\n  margin-top: 5px;\n}\n\n.member .social-links {\n  margin-top: 10px;\n}\n\n.member .social-links a {\n  color: #555;\n  text-decoration: none;\n  margin-right: 10px;\n  font-size: 18px;\n}\n\n.member .social-links a:hover {\n  color: #bfbfbf;\n}\n\n.countdown-box.svelte-1xheok0 {\n  min-width: 23em;\n  margin: 0 auto;\n  font-family: \"Dosis\", sans-serif;\n  background: linear-gradient(to bottom, #070928, #031024);\n  padding: 15px 10px;\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n}\n\n.countdown-box.svelte-1xheok0 {\n  width: auto; /* Adjust to content */\n  max-width: 550px;\n  margin: 20px auto; /* Center the box */\n  font-family: 'Dosis', sans-serif;\n  background: linear-gradient(to bottom, #070928, #031024);\n  padding: 15px 20px; /* Increased padding */\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n  white-space: nowrap; /* Prevents the text from wrapping */\n}\n\n.provider-text {\n  font-size: 10pt;\n  text-align: right;\n  color: #ffffff;\n}\n\n#wan-show-timer a {\n  text-decoration: none;\n  color: inherit;\n  display: block; /* Make the entire area clickable */\n}\n\n.discord-banner {\n  display: flex;\n  align-items: center;\n  background-color: #5865F2; /* Discord's blurple color from the color palette */\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: fit-content;\n}\n\n.discord-icon {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.discord-tag {\n  font-size: 14px;\n}\n\n.discord-tag {\n  background-color: #5865F2; /* Discord's purple color from the color palette */\n  padding: 5px 10px;\n  border-radius: 15px;\n  display: inline-block;\n}\n\n.discord-banner::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: calc(100% + 10px);\n  height: calc(100% + 10px);\n  border-radius: 20px;\n  z-index: -1;\n}\n\n.member {\n  margin-bottom: 20px;\n}\n\n.section h2 {\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .section {\n    flex: 0 0 100%; /* On smaller screens, each section takes up 100% of the available space */\n  }\n}\n\n@media (max-width: 768px) {\n  .member {\n    width: calc(50% - 18px);\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .footer-links {\n    margin-bottom: 0.5rem;\n  }\n}\n\n@media (max-width: 3840px) {\n  #game {\n    transform: scale(1.0); /* Scale down to 90% on smaller screens */\n    transform-origin: center;   \n  }\n\n  #nav-container {\n    transform: scale(0.8); /* Scale down to 80% on even smaller screens */\n    transform-origin: center;   \n  }\n}\n\n@media (max-width: 1920px) {\n  #game {\n    transform: scale(0.98); /* Scale down to 90% on smaller screens */\n    transform-origin: center;   \n    padding-left: 10px;\n  }\n\n  #whenplane {\n    transform: scale(0.98); \n  }\n}\n\n@media (max-width: 1200px) {\n  #game {\n    transform: scale(0.98);  \n    transform-origin: center;   \n    padding-left: 10px;\n    margin-left: 18px;\n  }\n\n  #whenplane {\n    transform: scale(0.98);\n    margin-top: 0px;  \n  }\n}\n\n@media (max-width: 1150px) {\n  #game {\n    transform: scale(0.96);  \n    transform-origin: center;   \n    padding-left: 10px;\n    margin-left: 18px;\n  }\n\n  #whenplane {\n    transform: scale(0.96);\n    margin-top: -2px;  \n  }\n}\n\n@media (max-width: 1100px) {\n  #game {\n    transform: scale(0.99);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n\n  #whenplane {\n    transform: scale(0.99);\n    margin-top: 0px;  \n  }\n}\n\n@media (max-width: 1070px) {\n  #game {\n    transform: scale(0.98);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1060px) {\n  #game {\n    transform: scale(0.97);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1050px) {\n  #game {\n    transform: scale(0.96);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1040px) {\n  #game {\n    transform: scale(0.95);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1030px) {\n  #game {\n    transform: scale(0.94);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1020px) {\n  #game {\n    transform: scale(0.93);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1010px) {\n  #game {\n    transform: scale(0.92);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n\n  #whenplane {\n    transform: scale(0.92);  \n  }\n}\n\n@media (max-width: 1000px) {\n  #game {\n    transform: scale(0.91);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -80px;\n  }\n}\n\n@media (max-width: 950px) {\n  #game {\n    transform: scale(0.86);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -100px;\n  }\n}\n\n@media (max-width: 900px) {\n  #game {\n    transform: scale(0.81);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -120px;\n  }\n\n  #whenplane {\n    transform: scale(0.81);\n    margin-top: -125px;  \n  }\n}\n\n@media (max-width: 850px) {\n  #game {\n    transform: scale(0.76);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -140px;\n  }\n\n  #whenplane {\n    transform: scale(0.76);\n    margin-top: -150px;  \n  }\n}\n\n@media (max-width: 800px) {\n  #game {\n    transform: scale(0.71);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 3px;\n    margin-top: -160px;\n  }\n\n  #whenplane {\n    transform: scale(0.71);\n    margin-top: -175px;  \n  }\n}\n\n@media (max-width: 750px) {\n  #game {\n    transform: scale(0.66);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 2px;\n    margin-top: -180px;\n  }\n\n  #whenplane {\n    transform: scale(0.66);\n    margin-top: -200px;  \n  }\n}\n\n@media (max-width: 600px) {\n  #game {\n    transform: scale(0.56);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 1px;\n    margin-top: -200px;\n  }\n\n  #whenplane {\n    transform: scale(0.56);\n    margin-top: -275px;  \n  }\n}\n\n@media (max-width: 550px) {\n  #game {\n    transform: scale(0.52);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -220px;\n  }\n}\n\n@media (max-width: 500px) {\n  #game {\n    transform: scale(0.48);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -240px;\n  }\n\n  #whenplane {\n    transform: scale(0.48);  \n    padding-top: -50px;\n  }\n}\n\n@media (max-width: 480px) {\n  #game {\n    transform: scale(0.46); /* Scale down to 50% on the smallest screens */\n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -248px;\n  }\n}\n\n@media (max-width: 450px) {\n  #game {\n    transform: scale(0.42);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -260px;\n  }\n}\n\n@media (max-width: 768px) {\n  .nav-links {\n    display: none;\n  }\n\n  .hamburger-menu {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
